import { useState } from "react";
import { ClienteRequest, ProdutoRequest } from "../controllers/Types";
import { toast } from 'react-toastify';
import ClienteController from "../controllers/ClienteController";
import ProdutoController from "../controllers/ProdutoController";
import { openBase64InNewTab } from "../shared/utils/helpers/base64";

interface Produto {
    prod_id: number;
    prod_descricao: string;
    prodID_promatec?: string;
    preco_venda: number;
}

interface UseModalRelatorioClienteProps {
    onClose: () => void;
    onSuccess: () => void;
}

const useModalRelatorioCliente = ({ onClose, onSuccess }: UseModalRelatorioClienteProps) => {

    const [cliente, setCliente] = useState([]);
    const [produto, setProduto] = useState([]);


    const fetchClientes = async (c: string) => {

        const request: ClienteRequest = {
        Nome: c,
        Celular: '', 
        Endereco: '',
        Bairro: '',
        Cidade: '',
        DataNascimento: null,
        Transportadora: '',
        ClienteAtivo: 'T',
    };
    
        const response = await ClienteController.Listar(request);
        if (response.StatusCode === 200) {
            return setCliente(response.Data || []);
        }
        setCliente([])
    };

    const fetchProdutos = async (v: string) => {
        const request: ProdutoRequest = {
            Descricao: v,
            CodigoBarras: '',
            Tipo: '',
            PartNumber: '',
            Grupo: '',
        };
        const response = await ProdutoController.Listar(request);
        if (response.StatusCode === 200) {
            setProduto(response.Data.map((item: Produto) => ({ id: item.prod_id, label: `${item.prodID_promatec} - ${item.prod_descricao}`, ...item })));
        }
    };

    const handleSubmit = async (values: any) => {    
        const produtoId = values.prod_id || '';
        const clienteId = values.cliente_id === '' ? null : Number(values.cliente_id);
        const clienteNome = values.cliente_nome?.cli_nome || '';

        const response = await ClienteController.Relatorio({
            ClienteId: clienteId,
            ClienteNome: clienteNome,
            ProdutoId: produtoId.id || null,
            Periodo: values.periodo,
        });

        if (response.StatusCode === 200) {
            toast.success('Relatório gerado com sucesso!');
            openBase64InNewTab(response.Data.base64, "my-file", "application/pdf");
        } else {
            toast.error('Houve algum erro. Verifique os dados!');
        }

        onSuccess();
        onClose();
    };

    return {
        cliente,
        produto,
        fetchClientes,
        fetchProdutos,
        handleSubmit
    }
}

export default useModalRelatorioCliente;